// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"307ada3c","453":"51bce4c5","667":"01c3823b","977":"68e4e009"}[chunkId] + ".chunk.js";
};